import { createSelector } from 'reselect'

const getIntlState = (state) => state.intl

export const selectCurrenLang = (state) => getIntlState(state).currentLang
export const selectAvailableLanguages = (state) => getIntlState(state).availableLanguages
export const selectShowButton = (state) => getIntlState(state).showButton


// WEBPACK FOOTER //
// ./src/store/intl/selectors.js